// extracted by mini-css-extract-plugin
module.exports = {"login":"login-form_login__1AH6t","links":"login-form_links__16FbX","blueBorder":"login-form_blueBorder__ccP13","button":"login-form_button__grjrI"};